import React from 'react'
import LightBox from 'react-image-lightbox'

class PhotoLightBox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      photoIndex: props.currentPhoto,
      crisp: null
    }
    this.loadPrevious = this.loadPrevious.bind(this)
    this.loadNext = this.loadNext.bind(this)
  }

  componentDidMount () {
    let crisp = document.getElementsByClassName('crisp-client')[0]
    if (crisp) {
      crisp.className += ' hidden'
      this.setState({crisp: crisp})
    }
  }

  componentWillUnmount () {
    if (this.state.crisp) {
      let theCrisp = this.state.crisp
      theCrisp.className = 'crisp-client'
    }
  }

  loadPrevious () {
    const {photoIndex} = this.state
    const {photos} = this.props
    this.setState({photoIndex: (photoIndex + photos.length - 1) % photos.length})
  }

  loadNext () {
    const {photoIndex} = this.state
    const {photos} = this.props
    this.setState({photoIndex: (photoIndex + 1) % photos.length})
  }

  render () {
    const {photos, hider} = this.props
    const {photoIndex} = this.state
    return (
      <LightBox
        mainSrc={photos[photoIndex].url.orginal}
        nextSrc={photos[(photoIndex + 1) % photos.length].url.orginal}
        prevSrc={photos[(photoIndex + photos.length - 1) % photos.length].url.orginal}
        onMovePrevRequest={this.loadPrevious}
        onMoveNextRequest={this.loadNext}
        onCloseRequest={hider}
        mainSrcThumbnail={photos[photoIndex].url.medium}
        nextSrcThumbnail={photos[(photoIndex + 1) % photos.length].url.medium}
        prevSrcThumbnail={photos[(photoIndex + photos.length - 1) % photos.length].url.medium}
      />)
  }
}

PhotoLightBox.propTypes = {
  photos: React.PropTypes.array,
  currentPhoto: React.PropTypes.number,
  hider: React.PropTypes.func
}

export default PhotoLightBox



// WEBPACK FOOTER //
// ./src/components/HorseInfo/PhotoLightBox.js